import { z } from "zod";

export const voiceMessagesTtsSchema = z.object({
  language: z.string().min(2),
  voice: z.string().min(2),
});

export const voiceMessageRecordingSlotSchema = z.object({
  mode: z.enum(["text", "recording"]),
  audioUrl: z.string().url().optional(),
  audioKey: z.string().optional(),
});

export const voiceMessagesRecordingsSchema = z.object({
  noAgentsAvailable: voiceMessageRecordingSlotSchema.optional(),
  queueWaiting: voiceMessageRecordingSlotSchema.optional(),
  queueConnecting: voiceMessageRecordingSlotSchema.optional(),
  recordingNotice: voiceMessageRecordingSlotSchema.optional(),
  voicemailGreeting: voiceMessageRecordingSlotSchema.optional(),
});

export const voiceMessagesSchema = z.object({
  tts: voiceMessagesTtsSchema.optional(),
  call: z
    .object({
      noAgentsAvailable: z.string().min(1).max(500).optional(),
    })
    .optional(),
  recording: z
    .object({
      recordingNotice: z.string().min(1).max(500).optional(),
    })
    .optional(),
  queue: z
    .object({
      connecting: z.string().min(1).max(500).optional(),
      waiting: z.string().min(1).max(500).optional(),
    })
    .optional(),
  voicemail: z
    .object({
      greeting: z.string().min(1).max(500).optional(),
    })
    .optional(),
  recordings: voiceMessagesRecordingsSchema.optional(),
});

export const callFlowSettingsSchema = z.object({
  audio: z
    .object({
      inputSensitivity: z.number().int().min(0).max(100).optional(),
      outputVolume: z.number().int().min(0).max(100).optional(),
      micMuted: z.boolean().optional(),
      speakerMuted: z.boolean().optional(),
      selectedMic: z.string().nullable().optional(),
      selectedSpeaker: z.string().nullable().optional(),
    })
    .optional(),
  voiceMessages: voiceMessagesSchema.nullable().optional(),
});

export type VoiceMessagesSettings = z.infer<typeof voiceMessagesSchema>;
export type CallFlowSettings = z.infer<typeof callFlowSettingsSchema>;
export type VoiceMessageRecordingSlot = z.infer<typeof voiceMessageRecordingSlotSchema>;
export type VoiceMessagesRecordings = z.infer<typeof voiceMessagesRecordingsSchema>;
